module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921082334_T.96675dab.jpg";